module.exports = __webpack_public_path__ + "img/38_41.4a91ba65.png";